<template>
    <div class="header">
        <div class="header__menu">
            <app-menu></app-menu>
        </div>
        <div class="header__user">
            <user-bar @logout="logout" v-if="isAuthInitialized"></user-bar>
        </div>
    </div>
</template>

<script>
import UserBar from '@/components/auth/UserBar.vue';
import AppMenu from '@/components/layout/Menu.vue';

export default {
  computed: {
    isAuthInitialized() {
      return this.$store.state.auth.isInitialized;
    },
  },

  methods: {
    logout() {
      this.$store.dispatch('logout').then(() => {
        this.$router.replace('login');
      });
    },
  },

  components: {
    UserBar,
    AppMenu,
  },
};
</script>

<style lang="scss">
    .header {
        width: 100%;
        display: block;
        overflow: hidden;
        margin-bottom: 40px;

        &__menu {
            float: left;
        }

        &__user {
            float: right;
        }
    }
</style>
